import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//import { pathToFileURL } from 'url';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuardService as AuthGuard } from './auth/auth-guard.service';
import { TranslateModule } from '@ngx-translate/core';

export const routes: Routes = [

  // {
  //   path: '',
  //   redirectTo: '/home',
  //   pathMatch: 'full'
  // },

  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    //runGuardsAndResolvers: 'always',
    children: [

      {
        path: '', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },

      {
        path: '',

        children: [
          { path: 'carm', loadChildren: () => import('./carm/carm.module').then(m => m.CarmModule) }
        ]
      },

      {
        path: '',

        children: [
          { path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportModule) }
        ]
      },

      {
        path: '',

        children: [
          { path: 'requestform', loadChildren: () => import('./requestform/requestform.module').then(m => m.RequestformModule) }
        ]
      },

      {
        path: 'paymentstatus/:orderid',
        children: [
          { path: '', loadChildren: () => import('./paymentstatus/paymentstatus.module').then(m => m.PaymentstatusModule) }
        ]
        // loadChildren: () => import('./paymentstatus/paymentstatus.module').then(m => m.PaymentstatusModule)
      },
      {
        path: 'payment/:agentcode',
        loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
      },
      {
        path: '',
        loadChildren: () => import('./paymenthistory/paymenthistory.module').then(m => m.PaymenthistoryModule)
      },
    ]
  },
  {

    path: 'home',

    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {

    path: 'register',

    loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule)
  },
  {

    path: 'privacy-policy',

    loadChildren: () => import('./privacypolicy/privacypolicy.module').then(m => m.PrivacypolicyModule)
  },
  {

    path: 'termofuse',

    loadChildren: () => import('./termofuse/termofuse.module').then(m => m.TermofuseModule)
  },
  
  {

    path: 'useragreement',

    loadChildren: () => import('./useragreement/useragreement.module').then(m => m.UseragreementModule)
  },
  // {
  //   path: 'payment/:agentcode',
  //   loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
  // },
  // {

  //   path: 'paymentstatus/:orderid',

  //   loadChildren: () => import('./paymentstatus/paymentstatus.module').then(m => m.PaymentstatusModule)
  // },
];

@NgModule({
  //imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
